import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { RESOURCES } from "@/config/resources";
import { PageHeader } from "@/components/dash/ui";
import DataTable from "@/components/dash/DataTable";

export default function ResourcePage() {
  const { key } = useParams();
  const config = RESOURCES[key];
  if (!config) return <Navigate to="/app/overview" replace />;
  return (
    <div>
      <PageHeader title={config.title} description={config.description} breadcrumb={`Workspace / ${config.title}`} />
      <DataTable key={key} config={config} />
    </div>
  );
}
